import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { REPORT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DerDashboardPage } from '@/features/dashboards/pages/DerDashboardPage';
import { derDashboardSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/der')({
  beforeLoad: () => requirePermission(REPORT_PERMISSIONS.DER_DASHBOARD_VIEW),
  validateSearch: derDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DER Dashboard">
      <Suspense fallback={<PageLoader />}>
        <DerDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
